module.exports = __webpack_public_path__ + "static/media/c2.43f39c8a.jpeg";